import FormErrorReducer from "reducers/global/form-errors-reducer";

import authReducer from "reducers/authReducer";
import draftReducer from "reducers/draftReducer";
import orderReducer from "reducers/orderReducer";
import systemListsReducer from "reducers/systemListsReducer";
import employeeReducer from "reducers/employeeReducer";
import customModalsReducer from "reducers/customModalsReducer";

import apiInfoReducer from "reducers/global/api-info-reducer";
import dashboardReducer from "reducers/dashboardReducer";
import locationsReducer from "reducers/menu/master-files/locations";
import systemListReducer from "reducers/menu/master-files/system-list";
import consumerGroupsReducer from "reducers/menu/master-files/consumer-groups";
import companyInfoReducer from "reducers/menu/master-files/company-info";
import storesReducer from "reducers/menu/master-files/stores";
import retailersReducer from "reducers/menu/master-files/retailers";
import jobsReducer from "reducers/menu/master-files/jobs-mainttenance";
import traitsReducer from "reducers/menu/master-files/traits";
import productsReducer from "reducers/menu/master-files/products-mainttenance";
import serviceTypesReducer from "reducers/menu/master-files/service-types";
import suppliersReducer from "reducers/menu/master-files/suppliers";
import serviceReportReducer from "reducers/menu/reporting/service-report";
import summaryReducer from "reducers/menu/summary";
import invoicingReducer from "reducers/menu/invoicing";
import exportReducer from "reducers/menu/export";
import miscChargesReducer from "reducers/menu/master-files/misc-charges";
import reportBuilderReducer from "reducers/menu/master-files/report-builder";
import questionLibraryReducer from "reducers/menu/master-files/question-library";
import planogramMaintenanceReducer from "reducers/menu/master-files/planogram-maintenance";
import emailBlasterReducer from "reducers/menu/email-blaster";
import workersMaintenanceReducer from "reducers/menu/master-files/workers-maintenance";
import fileManagerReducer from "reducers/menu/fileManager";
import orderExportLayoutsReducer from "reducers/menu/master-files/order-export-layouts";
import jobPostingsReducer from "reducers/menu/hr/job-postings";
import applicantsReducer from "reducers/menu/hr/applicants";
import scoringCriteriaReducer from "reducers/menu/hr/scoring-criteria";
import promptsReducer from "reducers/menu/hr/prompts";
import applicantActionsReducer from "reducers/menu/hr/applicant-actions";
import duplicationsReducer from "reducers/menu/hr/duplications";
import interviewCategoriesReducer from "reducers/menu/hr/interview-categories";
import interviewQuestionsReducer from "reducers/menu/hr/interview-questions";
import interviewsReducer from "reducers/menu/hr/interviews";
import ingestionFailuresReducer from "reducers/menu/ingestionFailuresReducer";

import scheduleReducer from "reducers/menu/schedule";
import profileReducer from "reducers/menu/profile";

export default {

    apiInfo: apiInfoReducer,
    auth: authReducer,
    customModals: customModalsReducer,
    dashboard: dashboardReducer,
    consumerGroups: consumerGroupsReducer,
    companyInfo: companyInfoReducer,
    draft: draftReducer,
    order: orderReducer,
    employee: employeeReducer,
    globalFormErrors: FormErrorReducer,

    jobs: jobsReducer,
    traits: traitsReducer,

    locations: locationsReducer,
    invoicing: invoicingReducer,
    export: exportReducer,
    miscCharges: miscChargesReducer,
    questionLibrary: questionLibraryReducer,
    planogramMaintenance: planogramMaintenanceReducer,
    reportBuilder: reportBuilderReducer,
    products: productsReducer,

    retailers: retailersReducer,

    systemList: systemListsReducer,
    serviceTypes: serviceTypesReducer,
    systemLists: systemListReducer,
    stores: storesReducer,
    suppliers: suppliersReducer,
    schedule: scheduleReducer,
    serviceReport: serviceReportReducer,
    summary: summaryReducer,
    emailBlaster: emailBlasterReducer,
    workersMaintenance: workersMaintenanceReducer,
    orderExportLayouts: orderExportLayoutsReducer,
    jobPostings: jobPostingsReducer,
    applicants: applicantsReducer,
    scoringCriteria: scoringCriteriaReducer,
    prompts: promptsReducer,
    applicantActions: applicantActionsReducer,
    duplications: duplicationsReducer,
    interviewCategories: interviewCategoriesReducer,
    interviewQuestions: interviewQuestionsReducer,
    interviews: interviewsReducer,
    ingestionFailures: ingestionFailuresReducer,

    fileManager: fileManagerReducer,
    profile: profileReducer
};
